import {OwnerOverviewComponent} from './owner-overview.component';
import {OwnerFormComponent} from './owner-form.component';
import {NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import {dynamicStateConfigFn, Ng2DynamicStateDeclaration} from '@ngx-ivengi/locale';
import {OwnerContactFormComponent} from './owner-contact-form.component';

export let CHILD_STATES: Ng2DynamicStateDeclaration[] = [
  {
    name: 'owner',
    component: OwnerOverviewComponent,
    future: true,
    data: {
      pageTitle: 'states.owner.pageTitle',
      scopes: ['owner:read']
    }
  },
  {
    name: 'owner.add',
    component: OwnerFormComponent,
    future: true,
    data: {
      pageTitle: 'states.owner.add.pageTitle',
      scopes: ['owner:create']
    }
  },
  {
    name: 'owner.edit',
    component: OwnerFormComponent,
    future: true,
    data: {
      pageTitle: 'states.owner.edit.pageTitle',
      scopes: ['owner:update']
    }
  },
  {
    name: 'owner.edit.contact',
    component: OwnerContactFormComponent,
    future: true,
    data: {
      pageTitle: 'states.owner.edit.contact.add.pageTitle',
      scopes: ['contact:create']
    }
  },
  {
    name: 'owner.edit.contact.edit',
    component: OwnerContactFormComponent,
    future: true,
    data: {
      pageTitle: 'states.owner.edit.contact.edit.pageTitle',
      scopes: ['contact:update']
    }
  }
];

@NgModule({
  imports: [
    UIRouterModule.forChild({
      states: CHILD_STATES,
      config: dynamicStateConfigFn
    }),
    TranslateModule
  ],
  exports: [UIRouterModule]
})
export class OwnerRoutingModule {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/owner/owner.routes.ts